import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { tasksId } from '../../../types/activityTasks';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { GameQuestionActivityThree } from './GameQuestionActivityThree';
import { imagesTheme3 } from '../../../assets/tema3';
import { voicesTypeControl } from '../../../types/audioType';
import { ButtonReturn } from '../../../components/common/ButtonReturn';

const gameQuestion = [
	{
		id: 1,
		question: "Al momento de que nuestra panera se vacíe, ¿Qué podemos hacer?",
		img: imagesTheme3.topic1.ChicaOxxoDudas,
		options: [
			{
				id: 1,
				text: "Limpiar el contenedor",
				isCorrect: true
			},
			{
				id: 2,
				text: "Llenarlo de inmediato"
			},
			{
				id: 3,
				text: "Descansar hasta que llegue el CEDIS"
			},
		]
	},
	{
		id: 2,
		question: "¿Cuántos días de duración tienen las donas? y ¿Cuántas cajas debe haber mínimo al lado de la panera?",
		img: imagesTheme3.topic1.ChicaOxxoDudas,
		options: [
			{
				id: 1,
				text: "3 a 5 días de duración y un mínimo 4 cajas",
			},
			{
				id: 2,
				text: "3 a 5 días de duración y un mínimo 5 cajas",
				isCorrect: true
			},
			{
				id: 3,
				text: "2 a 4 días y un mínimo de 5 cajas"
			},
		]
	},
	{
		id: 3,
		question: "¿Nuestra panera para que es exclusiva?",
		img: imagesTheme3.topic1.ChicaOxxoDudas,
		options: [
			{
				id: 1,
				text: "Pan a Granel",
			},
			{
				id: 2,
				text: "Pan Empacado"
			},
			{
				id: 3,
				text: "Todas las anteriores",
				isCorrect: true
			},
		]
	},
	{
		id: 4,
		question: "Al momento de recibir el producto por parte del CEDIS, ¿en qué debemos fijarnos?",
		img: imagesTheme3.topic1.ChicaOxxoDudas,
		options: [
			{
				id: 1,
				text: "Cantidad correcta y pan en buen estado",
				isCorrect: true
			},
			{
				id: 2,
				text: "Cantidad correcta y olor llamativo del pan"
			},
			{
				id: 3,
				text: "Que el pan esté en buen estado"
			},
		]
	},
	{
		id: 5,
		question: "¿Cuáles son los tipos de panes con los que contamos?",
		img: imagesTheme3.topic1.ChicaOxxoDudas,
		options: [
			{
				id: 1,
				text: "Pan a Granel, pan empacado, innovaciones y donas",
				isCorrect: true
			},
			{
				id: 2,
				text: "Pan empacado, innovaciones y donas"
			},
			{
				id: 3,
				text: "Innovaciones, donas y pan comercial"
			},
		]
	},
]

let pointsWin = 0

const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	gameQuestion: 3,
	win: 4,
	fail: 5
};

export const Theme3SubtopicOneActivityThree = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema3.activities.subtema1], 3);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 3 sub 1 act 3");
			ObserverEmitter.emit(EVENTS.tema3.actOne.initScene, 3);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_1.sub1_act3_a01T3)
	})

	const [selectQuestionGame, setSelectQuestionGame] = useState({
		question: "",
		img: "",
		options: [
			{
				id: 1,
				text: ""
			},
			{
				id: 2,
				text: ""
			},
			{
				id: 3,
				text: ""
			},
		]
	})
	const [numberQuestion, setNumberQuestion] = useState(0)
	const [saveResponse, setSaveResponse] = useState(1)


	const actionGameQuestion = (statusCorrect = 0) => {

		if (statusCorrect === 1) {
			pointsWin += 10
		}

		if (numberQuestion >= gameQuestion.length - 1) {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
			if (saveResponse >= 3) {
				setUiToShow(steps.win)
			} else {
				setUiToShow(steps.fail)
			}
			return
		}

		if (statusCorrect === 1) {
			setSaveResponse(saveResponse + 1)
		}

		setNumberQuestion(numberQuestion + 1)

	}

	const setDataQuestion = () => {
		const selectData = gameQuestion[numberQuestion]
		setSelectQuestionGame(selectData)
	}

	useEffect(() => {
		setDataQuestion()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [numberQuestion])


	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1, -2].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema3.actOne.initScene, 3);
						pointsWin = 0
						setSelectQuestionGame(
							{
								question: "",
								img: "",
								options: [
									{
										id: 1,
										text: ""
									},
									{
										id: 2,
										text: ""
									},
									{
										id: 3,
										text: ""
									},
								]
							}
						)
						setNumberQuestion(0)
						setSaveResponse(1)
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Ejercio: Panera Tipos de pan" />
					<DialogBarNew
						dialog={`¡Excelente! Vamos por muy buen camino, es momento de poner a prueba tu conocimiento. Contesta de manera correcta las siguientes preguntas:`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 1: Ejecución de panera y quesera"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.characterAnimations.saludo);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.activityScene)
							setUiToShow(steps.gameQuestion);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.gameQuestion && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<BarStatusActivies
						activities={tasksList}
					/>
					<GameQuestionActivityThree data={selectQuestionGame} actionGameQuestion={actionGameQuestion} />
				</>
			)}

			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={pointsWin}
						dialogModal="¡Excelente! Has respondido de manera correcta a las preguntas. Esto refleja tu destreza en el manejo de nuestra panera.."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 3,
									pointsWin: pointsWin,
									subtema: tasksId.tema3.activities.subtema1
								})
							);
							navigator("/home3/tema3/subtema1/activityFour");
						}}
					/>
				</>
			)}

			{uiToShow === steps.fail && (
				<>
					<ValidationResultModal
						title="Respuesta incorrecta."
						dialogModal="No te preocupes, el manejo de la panera es una habilidad que se perfecciona con la práctica."
						buttonTxt="Continuar"
						isCorrect={false}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 3,
									pointsWin: pointsWin,
									subtema: tasksId.tema3.activities.subtema1
								})
							);
							navigator("/home3/tema3/subtema1/activityFour");
						}}
					/>
				</>
			)}
		</>
	)
}
